<template>
  <div class="Layout__wrapper">
    <Navbar />
    <MobileNavbar />
    <b-container class="Layout__container mb-3">
      <slot />
    </b-container>
    <Footer />

    <!-- Banner global de reconex�o -->
    <SSEReconnectBanner />
  </div>
</template>

<script>
import Navbar from '@/components/Navbar'
import MobileNavbar from '@/components/MobileNavbar'
import Footer from '@/components/Footer'
import SSEReconnectBanner from '@/components/SSEReconnectBanner.vue' // ?? adicione aqui

export default {
  name: 'Layout',
  components: {
    Navbar,
    MobileNavbar,
    Footer,
    SSEReconnectBanner
  }
}
</script>

<style lang="scss" scoped>
.Layout__container {
  min-height: calc(100vh - 2rem - 33px - 56px);
}
</style>
